import React from 'react';

import UppercaseHeader from 'common/UppercaseHeader';

import 'css/components/developers/docs/api/_APIDocsTable.scss';

type Props = {
  title: string;
  rows: {
    subheading: string;
    heading: React.ReactNode;
    description: React.ReactNode;
  }[];
};

const APIDocsTable = ({ title, rows }: Props) => {
  return (
    <div className="apiDocsTable">
      <UppercaseHeader>{title}</UppercaseHeader>
      <div className="rows">
        {rows.map((row, i) => (
          <div className="row" key={i}>
            <div className="left">
              <div className="name">{row.heading}</div>
              <div className="subtext">{row.subheading}</div>
            </div>
            <div className="description">{row.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default APIDocsTable;
